import Vue from 'vue'
import App from './App.vue'

window.MAG = {};
Vue.config.productionTip = true;
Vue.prototype.$account = Account;
import './style/element-variables.scss'
import './style/new.scss'


import Element from 'element-ui';
import Account from "./class/Account/Account";

Vue.use(Element);
let app = new Vue({
  data: {
    auth: false,
    page: 'login',
    user: {},
  },
  render: h => h(App)
}).$mount('#app');
window.MAG.app = app;
window.acc = Account;